import useStyles from "./PersonalStyle";
import { Grid } from "@mui/material";
import styles from "../student.module.css";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import Button from "../../../../components/Button/Button";
import InputGroup from "../../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../../components/FormComponent/SelectGroup";
import { Gender, Employees } from "../../../../utils/DropDown";
import { httprequest } from "../../../../data/api";
import { toast, ToastContainer } from "react-toastify";
import { useUpload, useEditUpload } from "../../../../hooks/useUpload";

const CLASSES_ENDPOINT = "/api/v1/class";
const STUDENTS_ENDPOINT = "/api/v1/students";

const StudentProfile = ({ data }) => {
  const classes = useStyles();
  const { id } = useParams();
  const [classData, setClassData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [profilePic, setProfilePic] = useState(null);
  const [file, setFile] = useState();

  const [personalInfoForm, setPersonalInfoForm] = useState({
    first_name: data?.first_name,
    last_name: data?.last_name,
    admission_date: data?.admission_date,
    class_admitted: data?.class_id,
    email: data?.email,
    contact: data?.contact,
    guardian: data?.guardian_id,
    upload_id: data?.upload_id,
    gender: data?.gender,
    age: data?.age,
    display_pic: data?.display_pic || {}
    // address: ""
  });

  const handleProfileChange = (event) => {
    setFile(event.target.files[0]);
    const binaryData = [];
    binaryData.push(event.target.files[0]);
    setProfilePic(URL.createObjectURL(new Blob(binaryData)));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPersonalInfoForm({ ...personalInfoForm, [name]: value });
  };

  const handleUpdateInfo = async () => {
    setIsLoading(true);
    const display_pic = {};
    if (file) {
      // --| If an image with an upload id already exist, edit that image else, upload a new image
      const response = personalInfoForm?.display_pic?.upload_id ? await useEditUpload(file, personalInfoForm?.display_pic?.upload_id) : await useUpload(file);

      if (response.status === 200 && response.data.data) {
        display_pic.file_url = response.data.data?.file_url;
        display_pic.upload_id = response.data.data?.upload_id;
      } else {
        toast.error("Unable to upload profile picture");
        setIsLoading(false);
      }
    }
    httprequest.patch(`${STUDENTS_ENDPOINT}/${id}`, { ...personalInfoForm, display_pic }).then((res) => {
      setIsLoading(false);
      toast.success(res?.data?.message);
      window.location.reload();
    }).catch((err) => {
      setIsLoading(false);
      toast.error(err?.response?.data?.message);
    });
  };

  const getAllClasses = () => {
    httprequest.get(CLASSES_ENDPOINT).then((res) => {
      const physicalClasses = res?.data?.data?.filter((data) => data?.class_type === "physical");
      setClassData(physicalClasses);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  useEffect(() => {
    // The data will be from the Student get api endpint
    setPersonalInfoForm({ ...personalInfoForm, first_name: data?.first_name,
      last_name: data?.last_name,
      admission_date: data?.admission_date,
      class_admitted: data?.class_id,
      email: data?.email,
      contact: data?.contact,
      guardian: data?.guardian?.guardian_id,
      upload_id: data?.upload_id,
      gender: data?.gender,
      display_pic: data?.display_pic,
      age: data?.age });

    getAllClasses();
  }, [data]);

  const { first_name, last_name, contact, email, age, gender, admission_date, class_admitted, guardian } = personalInfoForm;

  return (
    <Grid container spacing={4}>
      <Grid item lg={4} md={4} sm={12} xs={12}>
        <div className={`${styles.border} left-container`}>
          <h4>Personal Information</h4>
          <h6>Personal Information of Student</h6>
          <div className={classes.profilecontainer}>
            <div className={classes.imageviewercontainer}>
              <div className={classes.imageviewer} style={{ backgroundImage: `url(${personalInfoForm?.display_pic?.file_url || profilePic})`, backgroundSize: "cover", backgroundRepeat: "no-repeat" }}>

              </div>
              <div className={classes.pickercontainer}>
                <input type="file" name="profile_picture" className={classes.profilepicker} onChange={handleProfileChange} />
                <CameraAltIcon className={classes.camera} />
              </div>
            </div>
          </div>
          <Button variant="primaryoutline" color="btnfontprimary" buttonSize="full" buttonName="Update Personal Information" onClick={handleUpdateInfo} isLoading={isLoading} />
        </div>
      </Grid>
      <Grid item lg={8} md={8} sm={12} xs={12}>
        <div className={`${styles.border} right-container`}>
          <Grid container spacing={2} className={classes.profileform}>

            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup inputType="text" label="First name" inputName="first_name" onChange={handleChange} defaultValue={first_name} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup inputType="text" label="Last name" inputName="last_name" onChange={handleChange} defaultValue={last_name} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup inputType="email" label="Email address" inputName="email" onChange={handleChange} defaultValue={email} disabled />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup inputType="text" label="Age" inputName="age" onChange={handleChange} defaultValue={age} />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <SelectGroup label="Gender" children={
                <select value={gender} name="gender" onChange={handleChange}>
                  <option value="">---Select  ---</option>
                  {Gender?.map((gend) => {
                    return (
                      <option key={gend?.key} value={gend?.key}>{gend?.text}</option>
                    );
                  })}
                </select>
              }
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup inputType="tel" label="Contact" inputName="contact" onChange={handleChange} defaultValue={contact} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <InputGroup inputType="date" label="Admission Date" inputName="admission_date" defaultValue={admission_date?.slice(0, 10)} onChange={handleChange} />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <SelectGroup label="Class Admitted to" children={
                <select name="class_admitted" onChange={handleChange} value={class_admitted}>
                  <option value="">---Select Labels ---</option>
                  {classData?.map((data) => {
                    return (
                      <option key={data?.id} value={data?.id}>{data?.class_name}</option>
                    );
                  })}
                </select>
              }
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={6}>
              <SelectGroup label="Parent/Guardian" children={
                <select value={guardian} name="guardian" onChange={handleChange}>
                  <option value="">---Select  ---</option>
                  {Employees?.map((parent) => {
                    return (
                      <option key={parent?.key} value={parent?.key}>{parent?.text}</option>
                    );
                  })}
                </select>
              }
              />
            </Grid>
          </Grid>
          <ToastContainer />
        </div>
      </Grid>
    </Grid>
  );
};

export default StudentProfile;
